import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { SET_NAVIGATION } from 'containers/Navigation/actions'
import { LOCATIONS_CHANGED } from 'containers/Locations/actions'
import navigation from 'containers/Navigation/reducer'
import locations from 'containers/Locations/reducer'
import Actions from 'reports/monthlyEvaluation/actions'

const config = handleActions(
  {
    [Actions.SET_TOKEN]: (state, { payload: token }) => ({ ...state, token })
  },
  { token: null, locale: null, timezone: null }
)

const init = handleActions(
  {
    [Actions.START_INIT]: state => ({ ...state, isFinished: false }),
    [Actions.FINISH_INIT]: state => ({ ...state, isFinished: true })
  },
  { isFinished: false }
)

const profiles = handleActions(
  {
    [[SET_NAVIGATION, ...LOCATIONS_CHANGED]]: (state) => ({
      ...state,
      profiles: [],
      visible: {},
      loading: true
    }),
    [Actions.RECEIVE_PROFILES]: (state, { payload: profiles }) => ({
      ...state,
      profiles,
      visible: profiles.reduce((acc, val) => {
        acc[val] = true
        return acc
      }
      , {}),
      loading: false
    }),
    [Actions.SHOW_PROFILE]: (state, { payload: profile }) => ({
      ...state,
      visible: { ...state.visible, [profile]: true }
    }),
    [Actions.HIDE_PROFILE]: (state, { payload: profile }) => ({
      ...state,
      visible: { ...state.visible, [profile]: false }
    }),
    [Actions.SHOW_ALL_PROFILES]: state => ({
      ...state,
      visible: state.profiles.reduce((acc, val) => {
        acc[val] = true
        return acc
      }, {})
    }),
    [Actions.HIDE_ALL_PROFILES]: state => ({
      ...state,
      visible: state.profiles.reduce((acc, val) => {
        acc[val] = false
        return acc
      }, {})
    })
  },
  {
    profiles: [],
    visible: {},
    loading: true
  }
)

const reports = handleActions(
  {
    [Actions.RECEIVE_REPORTS]: (state, { payload: reports }) => ({
      ...state,
      reports
    })
  },
  { reports: [] }
)

export default combineReducers({
  config,
  init,
  navigation,
  profiles,
  reports,
  locations
})
